<template>
	<div class="new_vip">
		<div class="content">
			<el-form :inline="true" :model="form" class="demo-form-inline">
				<el-form-item label="手机号查询">
					<el-input v-model="secah_mobile" placeholder="手机号" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="get_blackList">查询</el-button>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="add_dloing">添加黑名单</el-button>
			<el-table :data="tableData" border style="width: 100%;margin-top: 20px;">
				<el-table-column prop="headimgurl" label="头像" width="100">
					<template slot-scope="scope">
						<el-avatar
							size="large"
							:src="
								scope.row.headimgurl ||
									'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
							"
						></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="username" label="用户名"> </el-table-column>
				<el-table-column prop="mobile" label="手机号"> </el-table-column>
				<el-table-column prop="create_time" label="添加时间">
					<template slot-scope="scope">
						<div>{{ scope.row.create_time | dataFormat }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="operate" label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="del_blackList(scope.row.uid)"
							>移除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				style="float: right;margin-top: 20px;"
				hide-on-single-page
				background
				layout="prev, pager, next"
				:total="total"
				@current-change="pagination"
			>
			</el-pagination>
		</div>
		<el-dialog title="添加黑名单" :visible.sync="add_Visible" width="400px">
			<el-form>
				<el-form-item label="手机号">
					<el-input v-model="add_mobile" style="width: 200px;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="add_Visible = false">取 消</el-button>
				<el-button type="primary" @click="add_blackList">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { msgIgnoreList, addMsgIgnore, removeMsgIgnore } from "@/api/market";
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			tableData: [],
			page: 1,
			total: 0,
      add_mobile: "",
      secah_mobile:"",
			form: {},
			add_Visible: false,
		};
	},
	mounted() {
		this.get_blackList();
	},
	methods: {
		async get_blackList() {
			let data = {
				limit: 10,
				page: this.page,
				app_id: this.app_id,
				mobile: this.secah_mobile,
			};
			const res = await msgIgnoreList(data);
			if (res.code == 200) {
				this.tableData = res.data.data;
			}
		},
		pagination(val) {
			this.page = val;
			this.get_blackList();
		},
		add_dloing() {
			this.mobile = "";
			this.add_Visible = true;
		},
		async add_blackList() {
			try {
				let confirm = await this.$confirm(
					"此操作会将用户加入黑名单, 是否继续?",
					"警告",
					{
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					}
				).catch(() => {
					// this.mobile = "";
					this.add_Visible = false;
				});
				if (confirm == "confirm") {
					const res = await addMsgIgnore({
						app_id: this.app_id,
						mobile: this.add_mobile,
					});
					if (res.code == 200) {
						this.$message.success(res.msg);
						this.add_Visible = false;
						this.get_blackList();
					} else {
						this.$message.error(res.msg);
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		async del_blackList(id) {
			try {
				let confirm = await this.$confirm(
					"此操作会将用户移除黑名单, 是否继续?",
					"警告",
					{
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					}
				).catch(() => {});
				if (confirm == "confirm") {
					const res = await removeMsgIgnore({
						app_id: this.app_id,
						uid: id,
					});
					if (res.code == 200) {
						this.$message.success(res.msg);
						// this.add_Visible = false;
						this.get_blackList();
					} else {
						this.$message.error(res.msg);
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.new_vip {
	padding: 15px;
	height: 100%;
	background: #f1f2f6;
	overflow: auto;
	.content {
		background: #fff;
		padding: 5px 20px;
		height: 100%;
		overflow: auto;
	}
}
</style>
